var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard frame",attrs:{"id":"tableau"}},[(_vm.url)?_c('v-row',{staticClass:"card-no-footer-height"},[_c('iframe',{attrs:{"src":_vm.url}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }